<template>
<div class="card-container">
    <card class="card-login card-white">
        <Header pageTitle="Forgot Password"></Header>

        <div aria-live="polite">
            <center>{{forgotPasswordMessage}}</center>
            <base-input v-validate="'required|email'" :aria-invalid="errors.has('email')" name="email" :error="getError('email')" v-model="emailInput" placeholder="Email" addon-left-icon="tim-icons icon-email-85"></base-input>
            
            <base-button @click="onReturnToLoginClicked" class="btn btn-dark float-left" v-b-popover.hover.left="'Navigate back to the login page.'">
                <i class="tim-icons icon-double-left"></i> Return to login
            </base-button>

            <base-button @click="onForgotPasswordClicked" :disabled="isDisabled" class="btn btn-primary float-right" v-b-popover.hover.right="'Send password reset email.'">
                <i class="tim-icons icon-refresh-02"></i> Reset Password
            </base-button>
        </div>
        
    </card>
</div>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import axios from "@/axios";
import Header from "@/components/App/Header";

export default {
    name: "ForgotPassword",
    components: {
        Header,
    },
    mixins: [Utility],
    data() {
        return {
            emailInput: "",
            forgotPasswordMessage: "",
            disabled:false
        };
    },
    mounted() {},
    computed: {
        isDisabled(){
            return this.disabled
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        async onForgotPasswordClicked() {
            const isValidForm = await this.$validator.validateAll();
            if (isValidForm) {
                const email = this.emailInput;
                const self = this;

                self.disabled = true
                try {
                    var response = await axios.post("api/authentication/forgotpassword?email=" + email);
                    self.forgotPasswordMessage = response.data;
                } catch(err) {
                    this.$toast.success("If the email exists, you will receive a password reset link.");   
                }
                
            }
        },
        onReturnToLoginClicked() {
            this.$router.push({
                name: "Login",
            });
        },
    },
    watch: {
        emailInput: function () {
            this.forgotPasswordMessage = "";
        },
    },
};
</script>

<style scoped>
</style>
